import userService from '@/services/user';

import { SET_TOKEN, SET_REFRESH_TOKEN, SET_PROFILE, SET_BRANCH, SET_SIP_INFO, CLEAR } from './types';

const actions = {
  async login({ commit }, { username, password, branch }) {
    const { accessToken: token, refreshToken } = await userService.login(username, password, branch);

    commit(SET_TOKEN, token);
    commit(SET_REFRESH_TOKEN, refreshToken);

    const { firstName, lastName, profilePicture, sipUsername, sipPassword } = await userService.getProfile();

    commit(SET_PROFILE, { firstName, lastName, profilePicture, username });
    commit(SET_BRANCH, branch);
    commit(SET_SIP_INFO, { username: sipUsername, password: sipPassword });
  },

  async refreshToken({ commit, state }) {
    commit(SET_TOKEN, '');

    const { refreshToken } = state;
    const { accessToken: token } = await userService.refreshToken(refreshToken);

    commit(SET_TOKEN, token);
  },

  logout({ commit }) {
    commit(CLEAR);
  }
};

export default actions;
